import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../../_helpers";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";

const menuForm = {
  label: "",
  url: "",
  target: "",
  parent: null,
  order: null,
  _id: "",
};
// create slice
const name = "menu";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const menuActions = { ...slice.actions, ...extraActions };
export const menuReducer = slice.reducer;

function createInitialState() {
  return {
    CreateMenuItemResponse: {},
    getParentMenuList: [],
    getMenuListResponse: [],
    getCommitteeByIDResponse: {},
    menuForm: menuForm,
    getCommitteeHomePageIntegrationDataResponse: {},
    updateCommitteeHomePageResponse: {}, //update api response
    committeeMemberList: {},
    enableDisableMenuResponse: {},
    loading: false,
  };
}

function createReducers() {
  return {
    updateMenuForm,
    resetMenuForm,
    updateCommitteeHomePageReponseData,
  };
}

function updateMenuForm(state, action) {
  state.menuForm = action?.payload;
}

function resetMenuForm(state, action) {
  state.menuForm = menuForm;
}

function updateCommitteeHomePageReponseData(state, action) {
  state.getCommitteeHomePageIntegrationDataResponse.data.committeeHomePage =
    action?.payload;
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getParentMenuList: getParentMenuList(),
    CreateMenuItem: CreateMenuItem(),
    getMenuList: getMenuList(),
    deleteMenu: deleteMenu(),

    getCommitteeByID: getCommitteeByID(), //master get for edit
    updateCommittee: updateCommittee(), //master update
    getCommitteeMemberByCommitteeID: getCommitteeMemberByCommitteeID(), //site
    enableDisableMenu: enableDisableMenu(),

    getCommitteeHomePageIntegrationData: getCommitteeHomePageIntegrationData(),
    updateCommitteeHomePage: updateCommitteeHomePage(),
  };

  /* get parent menu list */
  function getParentMenuList() {
    return createAsyncThunk(
      `${name}/menu-items/parents`,
      //  async (params) => await fetchWrapper.get(`${baseUrl}/committee${params}`)
      async (params) => await fetchWrapper.get(`${baseUrl}/menu-items/parents`)
    );
  }

  /* get menu list */
  function getMenuList() {
    return createAsyncThunk(
      `${name}/menu-items`,
      //  async (params) => await fetchWrapper.get(`${baseUrl}/committee${params}`)
      async (params) => await fetchWrapper.get(`${baseUrl}/menu-items`)
    );
  }

  // get Menu by ID
  function getMenuItemById() {
    return createAsyncThunk(
      `${name}/getMenuItemById`,
      async (menuItemId) =>
        await fetchWrapper.get(`${baseUrl}/menu-items/${menuItemId}`)
    );
  }

  /* get committee by ID */
  function getCommitteeByID() {
    return createAsyncThunk(
      `${name}/getCommitteeByID`,
      async (id) => await fetchWrapper.get(`${baseUrl}/committee/${id}`)
    );
  }

  /* create new committee */
  function CreateMenuItem() {
    return createAsyncThunk(
      `${name}/CreateMenuItem`,
      async (params) => await fetchWrapper.post(`${baseUrl}/menu-items`, params)
    );
  }

  function deleteMenu() {
    return createAsyncThunk(`${name}/deleteMenu`, async (id) => {
      return await fetchWrapper.delete(`${baseUrl}/menu-items/${id}`, {
        status: false,
      });
    });
  }

  /* create update committee */
  function updateCommittee() {
    return createAsyncThunk(
      `${name}/updateCommittee`,
      async (params) =>
        await fetchWrapper.patch(`${baseUrl}/committee/${params?._id}`, params)
    );
  }

  /*get Committee Member By Committee ID */
  function getCommitteeMemberByCommitteeID() {
    return createAsyncThunk(
      `${name}/getCommitteeMemberByCommitteeID`,
      async (committeeID) =>
        await fetchWrapper.get(`${baseUrl}/users/committee/${committeeID}`)
    );
  }

  /* get Committee HomePage Integration Data */
  function getCommitteeHomePageIntegrationData() {
    return createAsyncThunk(
      `${name}/homepage`,
      async (id) =>
        await fetchWrapper.get(`${baseUrl}/committee/homepage/${id}`)
    );
  }

  /* update Committee HomePage */
  function updateCommitteeHomePage() {
    return createAsyncThunk(
      `${name}/updateCommitteeHomePage`,
      async (params) =>
        await fetchWrapper.patch(
          `${baseUrl}/committee/homepage/${params.get("_id")}`,
          params
        )
    );
  }

  // Enable or Disable Menu
  function enableDisableMenu() {
    return createAsyncThunk(
      `${name}/enableordisablemenuitem`,
      async (id) => await fetchWrapper.get(`${baseUrl}/menu-items/status/${id}`)
    );
  }
}

function createExtraReducers(builder) {
  builder
    //Parent menu list
    .addCase(extraActions.getParentMenuList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getParentMenuList.fulfilled, (state, action) => {
      state.loading = false;
      state.getParentMenuList = action?.payload;
    })
    .addCase(extraActions.getParentMenuList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //Get menu list
    .addCase(extraActions.getMenuList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getMenuList.fulfilled, (state, action) => {
      state.loading = false;
      state.getMenuListResponse = action?.payload;
    })
    .addCase(extraActions.getMenuList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //committee ID
    .addCase(extraActions.getCommitteeByID.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getCommitteeByID.fulfilled, (state, action) => {
      state.loading = false;
      state.getCommitteeByIDResponse = action?.payload;
    })
    .addCase(extraActions.getCommitteeByID.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //create New Menu Item
    .addCase(extraActions.CreateMenuItem.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.CreateMenuItem.fulfilled, (state, action) => {
      state.loading = false;
      state.CreateMenuItemResponse = action?.payload;
    })
    .addCase(extraActions.CreateMenuItem.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //get Committee HomePage Integration Data
    .addCase(
      extraActions.getCommitteeHomePageIntegrationData.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.getCommitteeHomePageIntegrationData.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getCommitteeHomePageIntegrationDataResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.getCommitteeHomePageIntegrationData.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    //update Committee HomePage
    .addCase(extraActions.updateCommitteeHomePage.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.updateCommitteeHomePage.fulfilled,
      (state, action) => {
        state.loading = false;
        state.updateCommitteeHomePageResponse = action?.payload;
      }
    )
    .addCase(extraActions.updateCommitteeHomePage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //get CommitteeMember By CommitteeID
    .addCase(extraActions.getCommitteeMemberByCommitteeID.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getCommitteeMemberByCommitteeID.fulfilled,
      (state, action) => {
        state.loading = false;
        state.committeeMemberList = action?.payload;
      }
    )
    .addCase(
      extraActions.getCommitteeMemberByCommitteeID.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    // Delete Menu Item
    .addCase(extraActions.deleteMenu.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(extraActions.deleteMenu.fulfilled, (state, action) => {
      state.loading = false;
      state.deleteMenuResponse = action.payload;
    })
    .addCase(extraActions.deleteMenu.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })

    // Enable or Disable Menu Item
    .addCase(extraActions.enableDisableMenu.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(extraActions.enableDisableMenu.fulfilled, (state, action) => {
      state.loading = false;
      state.enableDisableMenuResponse = action.payload;
    })
    .addCase(extraActions.enableDisableMenu.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    });
}
